import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["title", "src", "position"];
import React from 'react';
import { Menu as SemanticUIMenu } from 'semantic-ui-react';
import Image from '../../../../atoms/Image';
import InternalLink from '../../../../atoms/InternalLink';
import { ImagePropType } from '../../../../services/proptypes';
var defaultProps = {
  title: null,
  src: null,
  position: null
};
function Logo(_ref) {
  var title = _ref.title,
    src = _ref.src,
    position = _ref.position,
    imageProps = _objectWithoutProperties(_ref, _excluded);
  if (!title && !src) {
    return null;
  }
  var content = title;
  if (src) {
    content = /*#__PURE__*/React.createElement(Image, _extends({
      altText: "Logo"
    }, imageProps, {
      src: src
    }));
  }
  return /*#__PURE__*/React.createElement(SemanticUIMenu.Item, {
    className: "site-navigation-logo",
    header: true,
    position: position
  }, /*#__PURE__*/React.createElement(InternalLink, {
    to: "/"
  }, content));
}
Logo.defaultProps = defaultProps;
export default Logo;